import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const headerBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 3,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
    letterSpacing: '-0.015em',
};

export const subtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

/**
 * The two toggles sit on one line on a desktop and stack on a phone. They wrap rather than
 * collapsing into a Select below sm: two controls that do the same job at different widths
 * are two things to keep in step.
 */
export const controlsBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    mb: 3,
};

export const controlGroupStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
};

export const controlLabelStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontWeight: 600,
    mr: 0.5,
};

export const toggleGroupStyles: SxProps<Theme> = {
    flexWrap: 'wrap',
};

/** The resolved dates, so a preset is never the only statement of what is being shown. */
export const rangeCaptionStyles: SxProps<Theme> = {
    color: 'text.secondary',
    display: 'block',
    width: '100%',
};

export const alertStyles: SxProps<Theme> = {
    mb: 3,
    borderRadius: 3,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
};

export const emptyStateBoxStyles: SxProps<Theme> = {
    textAlign: 'center',
    py: 8,
};

export const emptyStateIconStyles = (theme: Theme): SxProps<Theme> => ({
    fontSize: 64,
    color: theme.palette.grey[300],
    mb: 2,
});

/**
 * Both charts run the full width and stack. Side by side they would each get half a year's
 * worth of horizontal room, which is exactly what twelve months of grouped bars cannot
 * spare -- see the scroller for the arithmetic.
 */
export const tableContainerStyles: SxProps<Theme> = {
    borderRadius: 3,
    border: '1px solid rgba(16,24,40,0.06)',
};

export const headerCellStyles: SxProps<Theme> = {
    fontWeight: 700,
    whiteSpace: 'nowrap',
};

/**
 * Figures are right-aligned and tabular so a column of them can be compared by eye, and so
 * a digit does not shift when the income toggle changes the number under it.
 */
export const numberCellStyles: SxProps<Theme> = {
    textAlign: 'right',
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
};

export const numberHeaderCellStyles: SxProps<Theme> = {
    fontWeight: 700,
    textAlign: 'right',
    whiteSpace: 'nowrap',
};

/** The unassigned bucket is real data, but it names nobody -- so it reads as a caveat. */
export const unassignedCellStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontStyle: 'italic',
};
